var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2737_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4081 5.7262H6.2345C4.93957 5.7262 3.88672 6.77905 3.88672 8.07398V17.4651C3.88672 18.7601 4.93957 19.8129 6.2345 19.8129H16.8813C16.8721 19.6763 16.8674 19.5384 16.8674 19.3994C16.8674 16.0422 19.589 13.3207 22.9462 13.3207C23.5765 13.3207 24.1843 13.4166 24.7559 13.5946V8.07398C24.7559 6.77905 23.7031 5.7262 22.4081 5.7262ZM9.36489 10.4218H7.7997C7.3677 10.4218 7.0171 10.0712 7.0171 9.63917C7.0171 9.20718 7.3677 8.85658 7.7997 8.85658H9.36489C9.79688 8.85658 10.1475 9.20718 10.1475 9.63917C10.1475 10.0712 9.79688 10.4218 9.36489 10.4218ZM14.3213 15.8999C12.5954 15.8999 11.1909 14.4954 11.1909 12.7696C11.1909 11.0437 12.5954 9.63917 14.3213 9.63917C16.0472 9.63917 17.4517 11.0437 17.4517 12.7696C17.4517 14.4954 16.0472 15.8999 14.3213 15.8999ZM28.2164 19.6822C28.2164 22.4364 25.9837 24.6691 23.2295 24.6691C20.4753 24.6691 18.2426 22.4364 18.2426 19.6822C18.2426 16.928 20.4753 14.6953 23.2295 14.6953C25.9837 14.6953 28.2164 16.928 28.2164 19.6822ZM22.8285 21.8518V20.0804H21.0571V19.2761H22.8285V17.5142H23.6329V19.2761H25.3995V20.0804H23.6329V21.8518H22.8285Z",
    fill: "#5926F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2737_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8081,
    height: 25.5834,
    fill: "white",
    transform: "translate(0.847656 0.350739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUp);
export default __webpack_public_path__ + "static/media/top_up.29508c39f726fd892c92b4083d9b871a.svg";
export { ForwardRef as ReactComponent };